import styled from "styled-components";

const HeroStyles = styled.div`
    background-image: url("${props => props.backgroundDesktop}");
    background-size: cover;
    background-position: center;

    @media (max-width: 600px) {
      background-image: url("${props => props.backgroundMobile}");
    }
    @media (min-width: 601px) and (max-width: 1023px) {
      background-image: url("${props => props.backgroundMobile}");
      height: 360px;
    }
`;
function Hero(props){
    return <HeroStyles
        className={"lg:w-1/2 xl:w-2/5 block p-12 pt-40"}
        backgroundDesktop={props.backgroundDesktop}
        backgroundMobile={props.backgroundMobile}
    ></HeroStyles>;
}

export default Hero;
